
import { getTaskList, getRelatedStaffsToAgent } from '../store/api/Services';
import { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Loader from 'react-loader-spinner'
import TaskItem from '../Components/Tasks/TaskItem';
import ModalRejectService from "../Components/Tasks/ModalRejectService";
import ModalReferToOther from "../Components/Tasks/ModalReferToOther";
import { Search } from "react-bootstrap-icons";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { getBaseInfoList } from '../../BaseInfo/store/api/BaseInfoApi';
import { InfoTypes } from '../../store/api/CommonFunctions';
const Tasks = () => {
  const dispatch = useDispatch();
  const tasks = useSelector(state => state.task?.tasks);
      const [stopDescList, setStopDescList] = useState(null);
  let isLoadingSaved = useSelector(state => state.loading?.isLoading);
  const find = () => {
    if (document.getElementById("inputSearch")) {
      let str = document.getElementById("inputSearch").value;
      if(str === "")
      {
        return;
      }
      var elList = document.getElementById("taksCard").querySelectorAll(".card");
      for(let i=0; i< elList.length; i++)
      {
        if(elList[i].textContent.search(str)>-1)
        {
          elList[i].scrollIntoView();
        }
      }
    }
  }
  useEffect(() => {
    document.body.classList = "notMain";
    document.title = "بی همتا-خدمات";
    async function fetchData() { dispatch(getRelatedStaffsToAgent()); dispatch(getTaskList(0, 100)); getBaseInfoList(InfoTypes.ServiceStopDesc, setStopDescList);}
    fetchData();
  }, []);

  useEffect(() => {

  }, [isLoadingSaved]);
  // if (!window.onkeydown) {
  //   window.onkeydown = function (e) {
  //     if (!keysDown) {
  //       return;
  //     }
  //     keysDown[e.key] = true;
  //     if (keysDown["g"] && keysDown["f"]) {
  //       find();
  //     }
  //   }
  // }
  // if (!window.onkeyup) {
  //   window.onkeyup = function (e) {
  //     if (!keysDown) {
  //       return;
  //     }
  //     keysDown[e.key] = false;
  //   }
  // }
  return (
    <div className="container-fluid mt-1" style={{ minHeight: '80vh' }}>
      <br />
      <div className="card" id = "taksCard">
        <div className="card-header headerStyle">کارتابل کارها</div>
        <div className="card-body bodyStyle">
          {isLoadingSaved && <Loader
            type="BallTriangle" color="#bb1370"
            height={50}
            width={50}
          />}
          {!isLoadingSaved &&
            <Fragment>
              <label className='errors mb-1'>این صفحه تنها 100 کار آخر اختصاص یافته را نمایش می دهد. برای جستجوی دقیق تر به صفحه <Link to="/Services/myTasks">جستجوی کارها</Link> مراجعه کنید.</label>
              <div className="row" style={{ margin: "auto" }}>
                <button className='btn btn-block' onClick={find} style={{ width: "auto", position: "absolute", right: "15px", marginTop: "5px", padding:"2px" }}><Search size={22}/></button>
                <input type="text" id="inputSearch" className="form-control" style={{ display: 'inline-block', paddingRight: "30px" }}></input>
                <button className='btn btn-block' onClick={find} style={{ width: "auto", position: "absolute", left: "15px", marginTop: "5px", padding:"2px" }}><Search size={22}/></button>
              </div>

              <ModalRejectService serviceID={0} serviceType={0} />
              <ModalReferToOther serviceID={0} serviceType={0} />
              <div className='row'>
              {tasks && Array.isArray(tasks) && tasks.map((item, i) => <TaskItem item={item} Rejectable={true} Referrable={true} key={i} stopDescList={stopDescList}/>)}
              </div>
            </Fragment>}
        </div>
      </div>
    </div>
  )
}
export default Tasks;
